import 'vite/modulepreload-polyfill';
//@ts-ignore
import { createApp } from "../../node_modules/vue/dist/vue.esm-bundler.js";
import { createRouter, createWebHistory } from 'vue-router';

import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';

import VueTippy from "vue-tippy"; // @ts-ignore
import 'tippy.js/dist/tippy.css';

import VueClickAway from 'vue3-click-away';

import { AuthPlugin } from '@/common/plugins/auth';
import { createPinia } from 'pinia';

import { createVfm, VueFinalModal } from 'vue-final-modal';
import 'vue-final-modal/style.css';

import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

import Toast, {
	POSITION as TOAST_POSITION,
	PluginOptions as ToastOptions
} from "vue-toastification";
import "vue-toastification/dist/index.css";

import '@/base.scss';
import '@/respondants.scss';
import '@/vue-toastification.scss';

import RespondantApp from './pages/RespondantApp.vue';
import routes from './routes';

const app = createApp({
	components: {
		RespondantApp
	},
	mounted(): void {
		this.$auth.created();
	},
	unmounted(): void {
		this.$auth.destroyed();
	}
});

const pinia = createPinia();
app.use(pinia);

const router = createRouter({
	history: createWebHistory(),
	routes
});

app.use(router);

app.use(AuthPlugin);

app.use(VCalendar, {});

app.component('font-awesome-icon', FontAwesomeIcon);
app.component('font-awesome-layers', FontAwesomeLayers);

//@ts-ignore
app.use(createVfm());
app.component('VueFinalModal', VueFinalModal);

app.use(VueClickAway);

app.use(VueTippy, {
	defaultProps: {
		arrow: false,
		theme: "huddle",
		offset: [0, 5]
	}
});

app.use(Toast, {
	position: TOAST_POSITION.BOTTOM_CENTER,
	hideProgressBar: true
} as ToastOptions);

/*
if (window.matchMedia) {
	if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
		document.documentElement.setAttribute('dark', '');
	}

	window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
		if (event.matches) {
			document.documentElement.setAttribute('dark', '');
		} else {
			document.documentElement.removeAttribute('dark');
		};
	});
}*/

app.mount("#happ");
